import { render, staticRenderFns } from "./PageDraggableDom.vue?vue&type=template&id=61184f88&"
import script from "./PageDraggableDom.vue?vue&type=script&lang=js&"
export * from "./PageDraggableDom.vue?vue&type=script&lang=js&"
import style0 from "./PageDraggableDom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports